import React from "react";
import { format } from "date-fns";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { IconButton } from "@mui/material";

const WeekNavigation = ({
  currentWeekIndex,
  weeklyData,
  currentWeekRange,
  dataLoading,
  onPreviousWeek,
  onNextWeek,
  onOpenCalendar,
  formatWeekDisplay,
}) => {
  return (
    <div className="min-w-[300px] bg-white rounded-xl p-2 flex items-center justify-between shadow-md">
      <div
        className="flex flex-col items-center cursor-pointer w-full"
        onClick={onOpenCalendar}
      >
        <div className="flex gap-1 md:gap-2 items-center justify-between w-full">
          <h3 className="text-[#6C6A6A] text-[10px] md:text-[12px] font-[600] font-[Lato]">
            Week:
          </h3>
          <p className="flex-1 text-center text-[#8B8B8B] text-[10px] md:text-[12px] font-[600] font-[Lato] p-1 border border-[#E6E6E6] shadow-md">
            <button
              onClick={(e) => {
                e.stopPropagation();
                onPreviousWeek();
              }}
              disabled={
                currentWeekIndex === weeklyData.length - 1 || dataLoading
              }
              className={`p-1 rounded-md ${
                currentWeekIndex === weeklyData.length - 1 || dataLoading
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:bg-gray-100"
              }`}
              title="Go to previous week (older)"
            >
              <ArrowBackIosIcon style={{ fontSize: 16, color: "#6C6A6A" }} />
            </button>
            {formatWeekDisplay()}
            <button
              onClick={(e) => {
                e.stopPropagation();
                onNextWeek();
              }}
              disabled={currentWeekIndex === 0 || dataLoading}
              className={`p-1 rounded-md ${
                currentWeekIndex === 0 || dataLoading
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:bg-gray-100"
              }`}
              title="Go to next week (newer)"
            >
              <ArrowForwardIosIcon style={{ fontSize: 16, color: "#6C6A6A" }} />
            </button>
          </p>
          <IconButton size="small">
            <CalendarMonthIcon style={{ fontSize: 18, color: "#0575E6" }} />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default WeekNavigation;